import { render, staticRenderFns } from "./description.vue?vue&type=template&id=4a5c2bc0"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"
import style0 from "./description.vue?vue&type=style&index=0&id=4a5c2bc0&lang=less"
import style1 from "./description.vue?vue&type=style&index=1&id=4a5c2bc0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5c2bc0')) {
      api.createRecord('4a5c2bc0', component.options)
    } else {
      api.reload('4a5c2bc0', component.options)
    }
    module.hot.accept("./description.vue?vue&type=template&id=4a5c2bc0", function () {
      api.rerender('4a5c2bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productDetail/description.vue"
export default component.exports